// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import cx from 'classnames';
// Components
import InputField from './CompanyField/CompanyField';
import OMTextArea from '../../OMComponents/OMTextArea/OMTextArea';
import CloudflareCaptcha from '../../CloudflareCaptcha/CloudflareCaptcha';
// Helpers
import { required, phoneNumber, notRequiredEmail } from '../../../helpers/reduxFormValidators';
// Constants
import { supportEmail } from '../../../constants';
import CAPTCHA_ACTIONS from '../../../helpers/captchaConstants';
// Styles
import * as styles from './CompanyContactUs.scss';

const CompanyContactUs = props => {
  const translate = props.translate('companyPage', 'contactsForm');
  const renderTextArea = (fieldProps) => {
    const { input, meta, name, placeholder } = fieldProps;
    return (
      <OMTextArea
        name={name}
        placeholder={placeholder}
        {...input}
        isInvalid={meta.touched && meta.error && !meta.active}
      />
    );
  };


  const fetchReCaptchaToken = (evt) => {
    props.fetchReCaptchaToken(evt);
  };

  return (
    <div id={props.id} className={cx('company-contact-us', styles.companyContactUs, props.className)} >
      <div className={styles.title}>{translate('contactWith')}&nbsp;{props.companyName || ''}</div>

      <div className={styles.wrapForm}>
        <form onFocus={props.onFocus} onSubmit={props.handleSubmit} noValidate="noValidate">
          <Field
            name="name"
            component={InputField}
            type="text"
            placeholder={`${translate('name').toString()}*`}
            validate={[required]}
            translateForError={props.translate('errorFieldMessages')}
            isRtl={props.isRtl}
          />

          <Field
            name="phone_number"
            component={InputField}
            type="text"
            normalize={value => value.replace(/[\D]/g, '')}
            placeholder={`${translate('phone').toString()}*`}
            validate={[required, phoneNumber]}
            translateForError={props.translate('errorFieldMessages')}
            isRtl={props.isRtl}
          />

          <Field
            name="email"
            component={InputField}
            type="email"
            placeholder={translate('email').toString()}
            validate={[notRequiredEmail]}
            translateForError={props.translate('errorFieldMessages')}
            isRtl={props.isRtl}
          />

          <Field
            name="message"
            component="textarea"
            placeholder={`${translate('message')}*`}
            validate={[required]}
          />

            {!!props.formError && (
              <p className="message" >
                {translate('submit_fail_message')} <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
              </p>
            )}

            {props.showCaptcha && (
              <CloudflareCaptcha
                fetchToken={fetchReCaptchaToken}
                action={props.isCommunityMember
                  ? CAPTCHA_ACTIONS.CONTACT_AGENCY_COMMUNITY
                  : CAPTCHA_ACTIONS.CONTACT_AGENCY}
                doReset={(!!props.formError && !props.formSubmitting) || props.formSubmitted}
              />
              )
            }
            <button disabled={!props.captcha} className={styles.submit}>
              {props.translate('companyPage', 'contactsForm', 'submit')}
              {props.formSubmitting && <i className="icon icon-om-spinner om-pulse" />}
            </button>
        </form>
      </div>
    </div>
  );
};

CompanyContactUs.propTypes = {
  translate: PropTypes.func,
  className: PropTypes.string,
  handleSubmit: PropTypes.func,
  isRtl: PropTypes.bool,
  formSubmitting: PropTypes.bool,
  formSubmitted: PropTypes.bool,
  showMessage: PropTypes.func,
  formError: PropTypes.object,
  onSubmit: PropTypes.func,
  reset: PropTypes.func,
  fetchReCaptchaToken: PropTypes.func,
  id: PropTypes.string,
  companyName: PropTypes.string,
  locale: PropTypes.string,
  isCommunityMember: PropTypes.bool,
  captcha: PropTypes.string,
  showCaptcha: PropTypes.bool,
  onFocus: PropTypes.func
};

export default reduxForm({
  form: 'company-contact-us'
})(CompanyContactUs);
